<template>
  <div class="bg-brand-light-gray flex flex-col md:py-12">
    <div
      class="w-full md:max-w-screen-lg flex flex-col bg-white rounded-sm shadow mx-auto py-10 px-10 mt-5"
    >
      <h2 class="text-2xl pb-5">Support Desk</h2>
      <h2 class="text-2xl py-1">Fast, 100% US-Based Email Support</h2>
      <Line />
      <p class="py-2 font-light">
        Rent Application Technology Services LLC ("Rent Application") strives to provide the highest
        quality email-based support for all of our customers. Our support team is local and
        in-house. You'll never be re-directed to a scripted support agent, you'll be connected with
        a product expert who can quickly assess and resolve issues when they arise.
      </p>
      <p class="py-2 font-light">
        Our normal support desk hours are Monday-Friday, 9:00am to 5:00pm, and 10am to 6pm on
        Saturdays and Sundays (Central Time). Please understand that support response times may be
        slightly longer on weekends and we observe federal holidays.
      </p>
      <p class="py-2 font-light">
        Please email us at
        <a :mailto="supportEmail" class="text-brand-green cursor-pointer">{{ supportEmail }}</a>
        for fast, effective customer service. Be sure to include as many details regarding your
        issue as possible.
      </p>

      <p class="py-2 font-light">
        For all Experian related issues, please contact our support at (888) 983-6403
      </p>
    </div>
  </div>
  <Footer />
</template>
